import * as React from 'react';

import type {ExternalServiceType} from 'nutshell-graphql-types';

type Props = {
    width: number;
    serviceType: ExternalServiceType;
};

export const MeetingImage = (props: Props) => {
    let name = '';
    switch (props.serviceType) {
        case 'ZOOM':
            name = 'zoom';
            break;
        case 'GOOGLE_MEET':
            name = 'google-meet';
            break;
        case 'MICROSOFT_TEAMS':
            name = 'microsoft-teams';
            break;
        default:
            return null;
    }

    return (
        <img
            alt={props.serviceType}
            style={{width: props.width}}
            src={`/include/images/empty-states/${name}-integration.png`}
        />
    );
};
